import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useElementSize } from 'usehooks-ts'

export const Accordeon = ({
  head,
  tail,
  colorMode,
}: {
  head: ReactNode
  tail: ReactNode
  colorMode: 'dark' | 'light' | undefined
}) => {
  const [isOpen, setOpen] = useState(false)
  const accRef = useRef<HTMLDivElement>(null)
  const [headref, { width, height }] = useElementSize()
  const [tailref, tailSize] = useElementSize()
  const [closedHeight, setClosedHeight] = useState(0)
  const [openHeight, setOpenHeight] = useState(0)

  useEffect(() => {
    setClosedHeight(height)
    setOpenHeight((tailSize.height + closedHeight) * 1.5)
  }, [])

  useEffect(() => {
    setClosedHeight(height)
  }, [
    height,
    width,
    tailSize.height,
    tailSize.width,
    headref,
    accRef,
    openHeight,
    isOpen,
  ])

  useEffect(() => {
    setOpenHeight((tailSize.height + closedHeight) * 1.5)
  }, [
    tailSize.height,
    tailSize.width,
    height,
    width,
    tailref,
    accRef,
    closedHeight,
    isOpen,
  ])

  return (
    <AccordeonRoot
      ref={accRef}
      style={{
        maxHeight: isOpen ? openHeight + 'px' : closedHeight + 'px',
        overflow: 'hidden',
      }}
    >
      <HeadContainer
        isOpen={isOpen}
        onClick={() => {
          if (isOpen && accRef.current) accRef.current.scrollIntoView()
          setOpen(!isOpen)
        }}
        ref={headref}
      >
        {head && head}
        <ArrowDown className='arrow' isOpen={isOpen} />
        <HeadBorder
          className='border'
          style={{
            borderColor:
              colorMode === 'dark'
                ? 'rgba(255,255,255,0.2)'
                : 'var(--brandblue-bright-5)',
          }}
        />
      </HeadContainer>
      <TailContainer ref={tailref}>{tail && tail}</TailContainer>
    </AccordeonRoot>
  )
}

const HeadBorder = styled.div`
  border-bottom: 1px solid var(--brandblue-bright-5);
  position: absolute;
  height: 2px;
  bottom: 0px;
  width: 100%;
  /* background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 10%,
    rgba(32, 35, 70, 1) 50%,
    rgba(255, 255, 255, 1) 90%
  ); */
`

const AccordeonRoot = styled.div`
  transition: max-height 0.5s ease-out;
  /* border-top: 2px solid black; */
  position: relative;
  display: inline-block;
  /* margin-bottom: px; */
  /* background-color: var(--site-background); */
  line-height: 30px;
  margin-bottom: 2px;
  z-index: 900;
  &:last-child {
    .border {
      border: 0;
    }
  }
`

const HeadContainer = styled.div<{ isOpen: boolean }>`
  cursor: pointer;
  max-width: 100vw;
  overflow: hidden;
  padding-bottom: 30px;
`
const TailContainer = styled.div`
  padding: 0px;
  text-align: left;
  max-width: 100vw;
  overflow: hidden;
  margin-bottom: 60px;
`
const ArrowDown = styled.div<{ isOpen: boolean }>`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: ${({ isOpen }) => (isOpen ? '60px' : '30px')};
  left: 50%;
  border-top: ${({ isOpen }) =>
    isOpen
      ? '10px solid var(--red-main)'
      : '10px solid var(--brandblue-bright-4)'};
  transition: transform 0.5s ease-out, border-top 0.25s ease-out;
  transform-origin: 50% 50%;
  transform: ${({ isOpen }) =>
    isOpen
      ? 'rotate(180DEG) translate(50%,-30px)'
      : 'rotate(0DEG) translate(-50%,0)'};

  &:hover {
    border-top: 10px solid var(--brandblue-main);
  }
`
const ArrowUp = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  border-bottom: 10px solid var(--text-color);
`
